"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronField = void 0;
const range_1 = __importDefault(require("lodash/range"));
class CronField {
    constructor() {
        /* PROPERTIES */
        this._base = 1;
        this.values = [];
        this.symbol = '*';
    }
    base(base) {
        this._base = base;
        return this;
    }
    fromString(input) {
        this.values = (input.match(/\d+/g) || []).map(n => parseInt(n));
        this.symbol = input.indexOf('L') > -1 ? 'L' : input.indexOf('#') > -1 ? '#' : '*';
        return this;
    }
    fromBoolArr(input) {
        this.values = input.map((b, i) => (b ? i + this._base : -1)).filter(i => i > this._base - 1);
        return this;
    }
    fromBoolFnc(n, fnc) {
        this.fromBoolArr((0, range_1.default)(n).map(v => fnc(v)));
        return this;
    }
    isComplex() {
        return this.symbol !== '*';
    }
    toString() {
        return this.values.length > 0
            ? this.values.length === 1
                ? this.values[0] + (this.isComplex() ? this.symbol : '')
                : this.values.join(this.isComplex() ? this.symbol : ',')
            : this.symbol;
    }
}
exports.CronField = CronField;
exports.default = CronField;
